import { recipe } from "@vanilla-extract/recipes";
import { style } from "@vanilla-extract/css";
import { rem } from "@huub-web/utils/css/rem";

import { theme } from "../../theme/css/theme.css";
import { responsive, responsiveCard } from "../../utils/responsive";
import { typographyDefinition } from "../../theme/typography";

export const HOUSE_CARD_BREAKPOINT = 500;

export const headerStyle = recipe({
  base: {
    overflow: "hidden",
  },
});

export const headerTitleStyle = style({
  fontWeight: "bold",
  ...responsiveCard({
    550: {
      ...typographyDefinition.displayS,
      fontWeight: "bold",
    },
  }),
});

export const contentStyle = style({
  gap: theme.spacings.s,
});

export const contentContainerStyle = style({
  height: "100%",
  gap: theme.spacings.s,
  ...responsiveCard({
    base: {
      flexDirection: "column",
    },
    [HOUSE_CARD_BREAKPOINT]: {
      flexDirection: "row",
      alignItems: "stretch",
      // gap: theme.spacings.m,
    },
  }),
});

export const headerImageStyle = recipe({
  base: {
    ...responsiveCard({
      base: {
        height: rem(144),
        minWidth: rem(160),
        width: "100%",
        maxWidth: "100%",
        borderRadius: theme.borderRadiuses.xs,
      },
      [HOUSE_CARD_BREAKPOINT]: {
        height: "auto",
        maxHeight: rem(144),
        width: "auto",
        aspectRatio: "4/3",
        borderRadius: theme.borderRadiuses.s,
        flexBasis: "35%",
      },
    }),
  },
  variants: {
    height: {
      l: {
        ...responsiveCard({
          [HOUSE_CARD_BREAKPOINT]: {
            maxHeight: "none",
            aspectRatio: "unset !important",
          },
        }),
      },
    },
  },
});

export const baseHeaderContainerClassName = style({
  display: "contents",
});

export const headerContentStyle = style({
  overflow: "hidden",
  alignSelf: "flex-start",
});

export const summaryContainerStyle = style({
  gap: theme.spacings.s,
  flexGrow: 1,
});

export const footerStyle = style({
  containerType: "inline-size",
  containerName: "headerSummary",
  flexDirection: "column",
  ...responsiveCard({
    600: {
      alignItems: "center",
      justifyContent: "space-between",
      flexDirection: "row",
    },
  }),
});

export const summaryStyle = style({
  flexWrap: "wrap",
  gap: `${theme.spacings.xxs} ${theme.spacings.xs}`,
  ...responsive(
    {
      base: {
        flexDirection: "column",
      },
      300: {
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "flex-start",
      },
    },
    {
      query: "container",
      value: "headerSummary",
    },
  ),
});

export const buttonStyle = style({
  ...responsiveCard({
    base: {},
    [HOUSE_CARD_BREAKPOINT]: {
      alignSelf: "flex-end",
    },
  }),
});

export const optionsStyle = style({
  alignSelf: "flex-start",
  gap: theme.spacings.s,
});

export const chipStyle = style({
  alignSelf: "flex-start",
});
